import { Carousel, GridCol, GridContainer, StackIntoView, useMediaDevice } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import Heading from '@websrc/App/Components/Heading/Heading'
import { ProductCard } from '@websrc/App/Components/ProductCard/ProductCard'
import { spotWrapperProps } from '@websrc/App/Helpers/spotWrapperProps'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapProductBand } from '@websrc/DataMappers/mapSpot'
import React, { useContext, useEffect, useState } from 'react'

import { LearnMoreButtonType } from '../Collapse/SpotCollapse'
import * as SC from './SpotProductBand.style'

export interface SpotProductBandProps {
  spot: ReturnType<typeof mapProductBand>['product_band']
  LearnMoreButton?: LearnMoreButtonType
  imageLazy?: boolean
  isTopOfPage?: boolean
}

export const SpotProductBand = ({
  LearnMoreButton,
  spot,
  imageLazy,
  isTopOfPage,
}: SpotProductBandProps) => {
  const [itemsPerPage, setItemsPerPage] = useState<number>(2)
  const device = useMediaDevice()
  const { matomoPageTemplate } = useContext(AppProviderContext)
  const t = useStaticText()

  const itemsToRender = [...spot.product_pages]

  useEffect(() => {
    switch (device) {
      case 'desktop':
        setItemsPerPage(4)
        break
      case 'tablet':
        setItemsPerPage(2)
        break
      default:
        setItemsPerPage(1)
    }
  }, [device])

  const pickProductPropsForCard = (product: any) => {
    const isCoralProduct = product.type === 'coral_web_science_pdp_single_product_page'
    return {
      url: product.url,
      price_discount: product.price_discount,
      price_list: product.price_list,
      title: product.title,
      thumbnail: product.thumbnail,
      product_number: product.product_number,
      school_grades: isCoralProduct
        ? `${t.search.grades} ${product.school_grades}`
        : product.school_grades,
      is_retired: product.is_retired,
    }
  }

  return (
    <GridContainer>
      <GridCol>
        <div {...spotWrapperProps(spot.caption)}>
          <Heading
            headline={spot.headline}
            label={spot.caption}
            level={isTopOfPage ? 1 : 2}
            size={'xxl'}
            skipWidth={true}
            style={{ gap: '10px', display: 'flex', flexDirection: 'column', marginBottom: '32px' }}
          />
        </div>
        {itemsToRender.length > 0 && (
          <StackIntoView stackGrandChildren={true}>
            <Carousel hidePaginationDots={true} itemsPerPage={itemsPerPage}>
              {itemsToRender.map((product, i) => {
                return (
                  <ProductCard
                    key={i}
                    lazyLoadImage={imageLazy}
                    onAddToCart={() => {
                      matomo.trackEvent(
                        'engagement',
                        matomoPageTemplate,
                        [spot.caption, spot.headline],
                        [t.ecom.add_to_cart],
                        'button'
                      )
                    }}
                    product={pickProductPropsForCard(product)}
                  />
                )
              })}
            </Carousel>
          </StackIntoView>
        )}
        {LearnMoreButton && (
          <SC.LearnMoreButtonWrapper>
            <LearnMoreButton />
          </SC.LearnMoreButtonWrapper>
        )}
      </GridCol>
    </GridContainer>
  )
}
